<template>
  <FormDialog
    :visible="visible"
    :title="dialogTitle"
    :width="1300"
    @close="close"
  >
    <div
      v-loading="loading"
      class="grouping-divide table direct-group-bind-dialog"
      element-loading-spinner="el-icon-loading"
    >
      <div style="display: flex; margin-bottom: 10px">
        <h3
          style="
            width: 53%;
            border-left: 2px solid #5b85ff;
            padding-left: 10px;
            height: 16px;
            line-height: 16px;
          "
        >
          未选择账户
        </h3>
        <h3
          style="
            width: 40%;
            border-left: 2px solid #5b85ff;
            padding-left: 10px;
            height: 16px;
            line-height: 16px;
          "
        >
          已选择账户<span v-if="enableBindDragSort">（拖动排序）</span>
          <span
            style="color: red; font-size: 14px; padding-left: 5px"
            >修改账户交易倍率后需要重登多账户交易端。</span
          >
        </h3>
      </div>

      <div style="display: flex">
        <el-table
          :data="userLeftList"
          row-key="id"
          :header-cell-style="{ background: '#F6F9FF' }"
          border
          height="400px"
          :row-class-name="style_none"
          style="width: 40%"
          @select="selectRowleft"
          @select-all="selectAllRowleft"
        >
          <el-table-column type="selection" width="55" />
          <el-table-column prop="userCode" align="center" label="登录账户" />
          <el-table-column
            prop="userName"
            align="center"
            label="登录姓名"
          />
          <el-table-column
            prop="userTypeName"
            align="center"
            label="账户类型"
          />
        </el-table>

        <div style="width: 100px" class="middleBtn">
          <div class="leftShiftBtn" @click="rightShiftFun">{{ '>>' }}</div>
          <div class="rightShiftBtn" @click="leftShiftFun">{{ '<<' }}</div>
        </div>

        <el-table
          :row-class-name="style_block"
          ref="rightBindTable"
          class="table_t client-direct-bind-right-table"
          :data="userRightList"
          row-key="id"
          :header-cell-style="{ background: '#F6F9FF' }"
          border
          height="400px"
          style="width: 40%"
          @select="selectRowright"
          @select-all="selectAllRowright"
        >
          <el-table-column type="selection" width="55" />
          <el-table-column
            v-if="enableBindDragSort"
            prop="userCode"
            width="100"
            align="center"
            label="优先级"
          >
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="userCode" align="center" label="登录账户" />
          <el-table-column
            prop="userName"
            align="center"
            label="登录姓名"
          />
          <el-table-column
            prop="userTypeName"
            align="center"
            label="账户类型"
          />
          <el-table-column align="center" label="交易倍率">
            <template slot-scope="scope">
              <div class="inpDiv">
                <el-input-number
                  v-model.number="scope.row.multiple"
                  style="width: 66px"
                  controls-position="right"
                  :min="0"
                  :max="10000"
                  :controls="false"
                  :precision="2"
                />
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <template slot="footer">
      <el-button
        class="indiv-btn"
        type="primary"
        size="small"
        :loading="bindSubmitting"
        @click="onBindSubmit"
      >
        确定
      </el-button>
    </template>
  </FormDialog>
</template>

<script>
import Sortable from 'sortablejs';
import '@/view/user/grouping/style.css';
import { applyGroupingRowDisplay } from './groupingAccountType';

/** 与 user/grouping returnData 一致：datas 或 data 数组；兼容 data 内嵌 */
function extractDirectReturnRows(resBody) {
  if (!resBody || typeof resBody !== 'object') {
    return [];
  }
  if (Array.isArray(resBody.datas)) {
    return resBody.datas;
  }
  if (Array.isArray(resBody.data)) {
    return resBody.data;
  }
  const d = resBody.data;
  if (d && typeof d === 'object' && !Array.isArray(d)) {
    if (Array.isArray(d.datas)) {
      return d.datas;
    }
    if (Array.isArray(d.list)) {
      return d.list;
    }
  }
  return [];
}

/** 与 grouping/editBtn 一致：已勾选进右侧 */
function isReturnRowChecked(el) {
  if (el == null) {
    return false;
  }
  const c = el.checked;
  return (
    c === true ||
    c === 1 ||
    String(c) === '1' ||
    String(c).toLowerCase() === 'true'
  );
}

function normalizeMultipleForEdit(m) {
  const n = Number(m);
  if (!Number.isFinite(n) || n <= 0) {
    return 1;
  }
  return n;
}

function normalizeBindRow(raw) {
  return applyGroupingRowDisplay(raw);
}

/** 绑定账户右侧列表拖拽排序，暂关闭；改为 true 可恢复 */
const ENABLE_BIND_DRAG_SORT = false;

/** 绑定账户到分组：左右穿梭、设置倍率 */
export default {
  name: 'DirectGroupBindDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    groupId: {
      type: [Number, String],
      default: null,
    },
    groupName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      enableBindDragSort: ENABLE_BIND_DRAG_SORT,
      loading: false,
      bindSubmitting: false,
      userLeftList: [],
      userRightList: [],
      selectionLeft: [],
      selectionRight: [],
      sortableInstance: null,
      sortableTimer: null,
    };
  },
  computed: {
    dialogTitle() {
      const n = this.groupName ? `「${this.groupName}」` : '';
      return `绑定交易账户${n}`;
    },
  },
  watch: {
    visible(v) {
      if (v && this.groupId != null && this.groupId !== '') {
        this.loadBindData();
      } else if (!v) {
        this.resetUi();
      }
    },
  },
  beforeDestroy() {
    this.destroySortable();
    if (this.sortableTimer) {
      clearTimeout(this.sortableTimer);
      this.sortableTimer = null;
    }
  },
  methods: {
    apiToken() {
      try {
        const t = JSON.parse(localStorage.getItem('token') || '{}');
        return t.apiToken || this.$store.state.usermsg.apiToken;
      } catch (e) {
        return this.$store.state.usermsg.apiToken;
      }
    },
    style_none() {
      return '';
    },
    style_block() {
      return 'tabHover';
    },
    destroySortable() {
      if (this.sortableInstance) {
        try {
          this.sortableInstance.destroy();
        } catch (e) {
          /* noop */
        }
        this.sortableInstance = null;
      }
    },
    initSortable() {
      if (!ENABLE_BIND_DRAG_SORT) {
        return;
      }
      this.destroySortable();
      if (this.sortableTimer) {
        clearTimeout(this.sortableTimer);
        this.sortableTimer = null;
      }
      this.sortableTimer = setTimeout(() => {
        const tableComp = this.$refs.rightBindTable;
        const tbody =
          tableComp &&
          tableComp.$el &&
          tableComp.$el.querySelector('tbody');
        if (!tbody) {
          return;
        }
        const that = this;
        this.sortableInstance = Sortable.create(tbody, {
          animation: 500,
          onEnd(evt) {
            const list = that.userRightList;
            const moved = list.splice(evt.oldIndex, 1)[0];
            list.splice(evt.newIndex, 0, moved);
            that.userRightList = list.slice();
          },
        });
      }, 1000);
    },
    resetUi() {
      this.destroySortable();
      if (this.sortableTimer) {
        clearTimeout(this.sortableTimer);
        this.sortableTimer = null;
      }
      this.userLeftList = [];
      this.userRightList = [];
      this.selectionLeft = [];
      this.selectionRight = [];
      this.loading = false;
      this.bindSubmitting = false;
    },
    close() {
      this.$emit('close');
    },
    /**
     * 与 user/grouping/editBtn 一致：仅 direct_returnData，
     * 按 checked 拆未选 / 已选；已选倍率用数字便于 el-input-number。
     */
    loadBindData() {
      this.loading = true;
      this.userLeftList = [];
      this.userRightList = [];
      this.selectionLeft = [];
      this.selectionRight = [];
      this.$request
        .post('/api_eval/direct_returnData', {
          token: this.apiToken(),
          /** 与旧 grouping 的 returnData 一致；文档字段为 id 时一并带上 */
          groupId: this.groupId,
          id: this.groupId,
        }, { skipToken: true, rawResponse: true })
        .then((res) => {
          this.tokenInvalid(res);
          if (res.data.code == 200) {
            const rows = extractDirectReturnRows(res.data);
            const left = [];
            const right = [];
            rows.forEach((el) => {
              const row = normalizeBindRow(el);
              if (isReturnRowChecked(el)) {
                row.multiple = normalizeMultipleForEdit(el.multiple);
                right.push(row);
              } else {
                left.push(row);
              }
            });
            this.userLeftList = left;
            this.userRightList = right;
            this.$nextTick(() => {
              this.initSortable();
            });
          } else {
            this.$alert(
              (res.data && (res.data.message || res.data.msg)) || '加载失败',
              {
                confirmButtonText: '确定',
                type: 'error',
                center: true,
              }
            );
            this.close();
          }
        })
        .catch(() => {
          this.$message.error('网络异常，请稍后重试');
          this.close();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /** 与 grouping/rightShiftFun 一致 */
    rightShiftFun() {
      for (let ii = 0; ii < this.selectionLeft.length; ii++) {
        for (let i = 0; i < this.userLeftList.length; i++) {
          if (this.userLeftList[i].id == this.selectionLeft[ii].id) {
            this.userLeftList.splice(i, 1);
          }
        }
      }
      const moved = this.selectionLeft.map((item) => ({
        ...item,
        multiple: normalizeMultipleForEdit(item.multiple),
      }));
      this.userRightList = this.userRightList.concat(moved);
      this.selectionLeft = [];
      this.$nextTick(() => {
        this.initSortable();
      });
    },
    /** 与 grouping/leftShiftFun 一致 */
    leftShiftFun() {
      for (let ii = 0; ii < this.selectionRight.length; ii++) {
        for (let i = 0; i < this.userRightList.length; i++) {
          if (this.userRightList[i].id == this.selectionRight[ii].id) {
            this.userRightList.splice(i, 1);
          }
        }
      }
      this.userLeftList = this.userLeftList.concat(this.selectionRight);
      this.selectionRight = [];
      this.$nextTick(() => {
        this.initSortable();
      });
    },
    selectRowleft(selection) {
      this.selectionLeft = selection;
    },
    selectAllRowleft(row) {
      this.selectionLeft = row;
    },
    selectRowright(selection) {
      this.selectionRight = selection;
    },
    selectAllRowright(row) {
      this.selectionRight = row;
    },
    /** 与 grouping/editSubmit 一致：accList、groupSort；接口为 direct_group_bind */
    onBindSubmit() {
      if (this.bindSubmitting) {
        return;
      }
      let str = '';
      const arr = [];
      let flag = true;
      this.userRightList.forEach((item) => {
        arr.push(item.id);
        const m = Number(item.multiple);
        if (Number.isFinite(m) && m > 0) {
          str += '|' + item.id + '_' + m;
        } else {
          flag = false;
        }
      });
      if (!flag) {
        this.$alert('交易倍率须大于0', {
          confirmButtonText: '确定',
          type: 'error',
          center: true,
        });
        return;
      }
      const accList = str.replace('|', '');
      this.bindSubmitting = true;
      this.$request
        .post('/api_eval/direct_group_bind', {
          token: this.apiToken(),
          groupId: this.groupId,
          accList,
          groupSort: arr,
        }, { skipToken: true, rawResponse: true })
        .then((res) => {
          this.tokenInvalid(res);
          if (res.data.code == 200) {
            this.$emit('success');
            this.close();
          } else {
            this.$alert(
              (res.data && (res.data.message || res.data.msg)) || '保存失败',
              {
                confirmButtonText: '确定',
                type: 'error',
                center: true,
              }
            );
          }
        })
        .catch(() => {
          this.$message.error('网络异常，请稍后重试');
        })
        .finally(() => {
          this.bindSubmitting = false;
        });
    },
  },
};
</script>

<style scoped>
.direct-group-bind-dialog {
  min-height: 420px;
}

/* 表头全选：勾选 / 半选 时复选框背景与边框 */
.direct-group-bind-dialog >>> .el-table__header-wrapper .el-checkbox__input.is-checked .el-checkbox__inner,
.direct-group-bind-dialog >>> .el-table__header-wrapper .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #5b85ff;
  border-color: #5b85ff;
}

.direct-group-bind-dialog >>> .el-table__header-wrapper .el-checkbox__input.is-checked .el-checkbox__inner::after {
  border-color: #fff;
}

.direct-group-bind-dialog >>> .el-table__header-wrapper .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/view/client/grouping/DirectGroupBindDialog.vue